import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Header from '../components/Header';

export default function TutorProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [tutor, setTutor] = React.useState(null);

  React.useEffect(() => {
    fetch('/api/tutors')
      .then(res => res.json())
      .then(data => {
        const found = data.find(t => String(t.id) === String(id));
        setTutor(found || null);
      });
  }, [id]);

  if (!tutor) {
    return (
      <div>
        <Header />
        <div style={{padding: '2.5rem', background: '#f7f9fb', minHeight: '100vh'}}>
          <div style={{background: '#fff', borderRadius: 18, maxWidth: 480, margin: '3rem auto', padding: '2.5rem', textAlign: 'center'}}>
            <h2>Tutor not found</h2>
            <button onClick={() => navigate(-1)} style={{marginTop: 20, background: '#eee', color: '#222', border: 'none', borderRadius: 8, padding: '0.6rem 1.5rem', fontWeight: 600, fontSize: 16, cursor: 'pointer', boxShadow: '0 1px 4px #eee'}}>Back</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div style={{padding: '2.5rem', background: '#f7f9fb', minHeight: '100vh'}}>
        <div style={{
          background: '#fff',
          border: 'none',
          boxShadow: '0 2px 16px #e0e0e0',
          borderRadius: 18,
          maxWidth: 480,
          margin: '3rem auto',
          padding: '2.5rem 2.5rem 2rem 2.5rem',
          display: 'flex',
          flexDirection: 'column',
          gap: 18
        }}>
          <h1 style={{fontSize: '2.1rem', fontWeight: 800, marginBottom: 12, letterSpacing: 1, color: '#111'}}>Tutor Profile</h1>
          <div style={{fontSize: 20, lineHeight: 1.7, marginBottom: 12}}>
            <div><b>ID:</b> {tutor.id || '\u2014'}</div>
<div><b>Subject{Array.isArray(tutor.subjects) && tutor.subjects.length > 1 ? 's' : ''}:</b> {Array.isArray(tutor.subjects) && tutor.subjects.length > 0 ? tutor.subjects.join(', ') : '\u2014'}</div>
<div><b>Gender:</b> {tutor.gender || '\u2014'}</div>
<div><b>Gradutaion Year:</b> {tutor.gradYear || '\u2014'}</div>
<div><b>Available Time:</b> {tutor.time || '\u2014'}</div>
          </div>
          <div style={{display: 'flex', gap: 14, marginTop: 10}}>
            <button onClick={() => navigate(-1)} style={{
              background: '#eee',
              color: '#222',
              border: 'none',
              borderRadius: 8,
              padding: '0.6rem 1.5rem',
              fontWeight: 600,
              fontSize: 16,
              cursor: 'pointer',
              boxShadow: '0 1px 4px #eee'
            }}>Back</button>
            <button onClick={() => navigate(`/register?tutor=${tutor.id}`)} style={{
              background: '#04d664',
              color: 'white',
              border: 'none',
              borderRadius: 8,
              padding: '0.6rem 1.5rem',
              fontWeight: 600,
              fontSize: 16,
              cursor: 'pointer',
              boxShadow: '0 1px 4px #cceedd'
            }}>Book Session</button>
          </div>
        </div>
      </div>
    </div>
  );
}
